import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Routes, Route, HashRouter } from "react-router-dom";
import Back2 from "./Videos/back2.mp4";

function Layout() {
  return (
    <div className="relative w-full min-h-screen">
      <video
        autoPlay
        muted
        loop
        playsInline
        className="fixed top-0 left-0 z-0 w-screen h-screen object-cover"
      >
        <source src={Back2} type="video/mp4" />
      </video>

      <div className="relative z-10">
        <App />
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HashRouter>
      <Routes>
        <Route path="/*" element={<Layout />} />
      </Routes>
    </HashRouter>
  </React.StrictMode>
);

reportWebVitals();
